import { type JSX } from "react";
import { cn, formatdDate } from "../../lib/utils";
import { TooltipCell } from "../table/TooltipCell";
import { IconMaterial } from "../shared/iconMaterial/IconMaterial";
import { TOrder, useOrders } from "../../context/OrdersProvider";
import Badge from "../shared/ui/Badge";


type BodyTableProps = {
  id?: string | null;
  rows: TOrder[];
  handleRowClick: (order: TOrder) => void
  isPagination?: boolean;
  isLoadingSendInvitation: boolean;
  onRowClick?: (id: string) => void;
  handleClickInviteButton: (id: string) => void;
};

export const BodyTableOrders = ({
  rows,
  handleRowClick,
}: BodyTableProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black text-sm text-primary-light",
    "align-middle min-w-0",
  );
  const { selectedOrder } = useOrders()

  return (
    <>
      {rows.map((order, index) => {
        return (
          <tr
            key={index}
            className={`${selectedOrder?.id === order?.id ? 'bg-background-light-gray' : ''}`}
          >
            <td
              onClick={() => handleRowClick(order)}
              className={cn(
                baseCellClassName,
                "relative overflow-hidden cursor-pointer group",
                selectedOrder?.id === order?.id ? "border-l-[2px] border-primeblue" : ""
              )}
            >
              <div className="rounded-l-lg flex items-center">
                <TooltipCell
                  content={order.external_order_id}
                  className="group-hover:text-primeblue"
                />
                <IconMaterial
                  filled
                  icon="chevron_right"
                  className="cursor-pointer hidden group-hover:block group-hover:text-primeblue"
                  size={16}
                />
              </div>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell
                content={order.prescription_detail.patient_first_name + ' ' + order.prescription_detail.patient_last_name}
                subcontent={"MRN: " + order.prescription_detail.patient_mrn}
              />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={formatdDate(order.created_stamp) || '-'} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.prescription_detail.appoint_date} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order?.target_device as string} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={order.medical_system} />
            </td>

            <td className={cn(baseCellClassName)}>
              <Badge
                status={order.status}
              />
            </td>
          </tr>

        );
      })}
    </>
  );
};
